import { useMemo } from "react";
import { useBranchLimits } from "../BranchLimits";
import { usePatronLocation } from "../pages/resource/usePatronLocation";
import { useLocationConfiguration } from "../LocationConfiguration";

export function useSingleBranch() {
  const { displayInPickupLocationIds } = useBranchLimits();
  const { pickupLocation: patronPickupLocation } = usePatronLocation();
  const { locationConfiguration } = useLocationConfiguration();
  const { pacSettings } = locationConfiguration || {};
  const { userActionSettings, displaySettings } = pacSettings || {};
  const { restrictTitleLevelHolds } = userActionSettings || {};
  const { displaySelectPickupLocation } = displaySettings || {};

  const singleBranchIds = useMemo(() => {
    // TODO restrictTitleLevelHolds supercedes everything

    if (displayInPickupLocationIds?.length === 1) {
      return {
        singleFillBranchId: displayInPickupLocationIds[0],
        singlePickupBranchId: displayInPickupLocationIds[0],
      };
    }

    const singleFillBranchId =
      patronPickupLocation && restrictTitleLevelHolds
        ? patronPickupLocation
        : null;
    const singlePickupBranchId =
      patronPickupLocation &&
      (restrictTitleLevelHolds || !displaySelectPickupLocation)
        ? patronPickupLocation
        : null;
    return {
      singleFillBranchId,
      singlePickupBranchId,
    };
  }, [
    patronPickupLocation,
    restrictTitleLevelHolds,
    displaySelectPickupLocation,
    displayInPickupLocationIds,
  ]);

  return singleBranchIds;
}
